import { Box, Typography } from '@mui/material';
import { COLORS } from '../talkTreeShared/Tree/constants/theme';

const APPSNACKBAR_CONFIGS = {
  success: { bg: COLORS.success },
  error: { bg: COLORS.error },
  warning: { bg: COLORS.warning },
  info: { bg: COLORS.primary },
};

function AppSnackbar({ toast, onClose }) {

  if (!toast) return null;

  const config = APPSNACKBAR_CONFIGS[toast.type] || APPSNACKBAR_CONFIGS.info;
  const isSuccess = toast.type === 'success';

  return (
    <Box
      role={isSuccess ? 'status' : 'alert'}
      aria-live={isSuccess ? 'polite' : 'assertive'}
      sx={{
        position: 'fixed',
        top: '32px',
        right: '24px',
        zIndex: 9999,
        maxWidth: '380px',
        width: 'calc(100vw - 48px)',
        backgroundColor: config.bg,
        borderRadius: '12px',
        padding: '16px 20px',
        boxShadow: '0 8px 32px rgba(0,0,0,0.22)',
        display: 'flex',
        flexDirection: 'column',
        animation: 'toast-in 0.25s ease',
        textAlign: 'left',
      }}
    >
      <style>{`
        @keyframes toast-in {
          from { opacity: 0; transform: translateY(12px) scale(0.97); }
          to   { opacity: 1; transform: translateY(0) scale(1); }
        }
      `}</style>

      <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: '12px' }}>
        <Box>
          <Typography sx={{ fontWeight: 700, fontSize: '15px', color: '#fff', lineHeight: 1.4,    mb: '6px' }}>
            {toast.title}
          </Typography>
          {toast.message && (
            <Typography sx={{ fontSize: '14px', color: '#fff', lineHeight: 1.6,    opacity: 0.95, whiteSpace: 'pre-line' }}>
              {toast.message}
            </Typography>
          )}
        </Box>
        <Box
          component="button"
          onClick={onClose}
          aria-label="Dismiss notification"
          sx={{
            background: 'none', border: 'none', cursor: 'pointer',
            color: '#fff', flexShrink: 0, padding: '2px', mt: '1px',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            borderRadius: '4px', opacity: 0.85,
            '&:hover': { opacity: 1 },
            '&:focus-visible': { outline: '2px solid #fff', outlineOffset: '2px' },
          }}
        >
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M3 3L13 13M13 3L3 13" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
          </svg>
        </Box>
      </Box>
    </Box>
  );
}

export default AppSnackbar;